import React, { useState, useEffect } from "react";

export default function Countdown(props) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Set target date (30 days from now by default, or use props.targetDate)
  const getTargetDate = () => {
    if (props.targetDate) {
      return new Date(props.targetDate);
    }
    const target = new Date();
    target.setDate(target.getDate() + 30);
    return target;
  };

  useEffect(() => {
    const targetDate = getTargetDate();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) {
        // Countdown has ended
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    // Update countdown every second
    const interval = setInterval(updateCountdown, 1000);
    
    // Initial call
    updateCountdown();

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, [props.targetDate]);

  const TimeUnit = ({ value, label }) => (
    <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-xl border border-white border-opacity-30 flex flex-col p-4 md:p-6 min-w-[80px] md:min-w-[120px]">
      <span className="countdown font-mono text-3xl md:text-5xl font-bold">
        <span 
          style={{ "--value": value.toString().padStart(2, '0') }} 
          aria-live="polite" 
          aria-label={value.toString().padStart(2, '0')}
        >
          {value.toString().padStart(2, '0')}
        </span>
      </span>
      <span className="text-sm md:text-base mt-2 font-medium">{label}</span>
    </div>
  );

  return (
    <div className="py-20 bg-gradient-to-r from-purple-600 to-blue-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {props.title || "Launch Countdown"}
          </h2>
          <p className="text-xl max-w-2xl mx-auto">
            {props.description || "DeepDocs AI is launching soon! Be among the first to experience the future of clinical documentation."}
          </p>
        </div>
        
        {/* Countdown Timer */}
        <div className="flex justify-center">
          <div className="grid grid-flow-col gap-4 md:gap-8 text-center auto-cols-max">
            <TimeUnit value={timeLeft.days} label="Days" />
            <TimeUnit value={timeLeft.hours} label="Hours" />
            <TimeUnit value={timeLeft.minutes} label="Minutes" />
            <TimeUnit value={timeLeft.seconds} label="Seconds" />
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="text-center mt-12">
          {props.showCTA !== false && (
            <>
              <button 
                onClick={props.onGetEarlyAccess}
                className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 mr-4"
              >
                {props.earlyAccessText || "Get Early Access"}
              </button>
              <button 
                onClick={props.onLearnMore}
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-purple-600 transition duration-300"
              >
                {props.learnMoreText || "Learn More"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
